function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-menu_svg__clip0)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.436 2.134H1.564C.702 2.134 0 2.836 0 3.699s.702 1.565 1.564 1.565h13.872a1.566 1.566 0 000-3.13zM15.436 6.935H1.564C.702 6.935 0 7.637 0 8.5s.702 1.565 1.564 1.565h13.872a1.566 1.566 0 000-3.13zM15.436 11.736H1.564a1.566 1.566 0 000 3.13h13.872c.862 0 1.564-.702 1.564-1.564 0-.864-.702-1.566-1.564-1.566z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-menu_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h17v17H0z"
})));

function SvgIconMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconMenu;